import _keysInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/keys';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import { TagName } from '../../constants/html.js';

var onA11yKeyDown = function onA11yKeyDown(event, options, callback) {
  var keys = _keysInstanceProperty(options);
  if (_includesInstanceProperty(keys).call(keys, event.key)) {
    var _ref = event.target,
      tagName = _ref.tagName;
    if (tagName !== TagName.Input && tagName !== TagName.Textarea && tagName !== TagName.Button && tagName !== TagName.Anchor) {
      event.preventDefault();
    }
    if (callback) return callback();
    return event.target.dispatchEvent(new Event('click', {
      bubbles: true
    }));
  }
  return false;
};

export { onA11yKeyDown };
//# sourceMappingURL=onA11yKeyDown.js.map
